import { useRef } from 'react';
import { useToggle } from '@/hooks/useToggle';
import IconButton from '@/components/IconButton';
import { ExposureIcon } from '@/icons';
import ExposureMenu from './ExposureMenu';
import type { FaceFilterSettings } from '../../types';
import { classes } from './utils';

export type ExposureControlProps = {
  filter: FaceFilterSettings;
  onUpdate: (filter: FaceFilterSettings) => void;
};

export default function ExposureControl({
  filter,
  onUpdate,
}: ExposureControlProps) {
  const menuToggleRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle();

  return (
    <>
      <div ref={menuToggleRef}>
        <IconButton onClick={() => toggleMenu()}>
          <ExposureIcon className={classes.icon} />
        </IconButton>
      </div>
      {isMenuOpen && (
        <ExposureMenu
          anchorTo={menuToggleRef.current}
          open
          filter={filter}
          onUpdate={onUpdate}
          onClose={() => toggleMenu(false)}
        />
      )}
    </>
  );
}
